import WebApiService from "@/services/webapi.service.js";
import Magazzino from "@/models/magazzino.model.js";

const state = {
    magazzini: []
}

const getters = {
    getMagazzini: (state) => {
        return state.magazzini;
    },
    getDescrMagazzino: (state) => (codiceMagazzino) =>{
        if(state.magazzini){
            let magazzino = state.magazzini.find(item => item.CodiceMagazzino === codiceMagazzino);
            if(magazzino){
                return magazzino.DescrizioneMagazzino ?? "-";
            }else{
                return "-";
            }
        }else{
            return "-";
        }
    }
}

const mutations = {

    setMagazzini: (state, magazzini) => {
        state.magazzini = magazzini;      
    }
}

const actions = {

    getMagazzini: ({commit}, data) => {                                                                                                              
        return WebApiService.get('magazzini/GetMagazzini', data.token).then(
        (data) => {              
                if(data.StatusCode !== 200){
                    return [false, data.Message];
                }
                else{                  
                    commit("setMagazzini", data.Data.map(
                        o => { return Object.assign(new Magazzino(), o) }
                    ));
                    return [true, ""];            
                }
            },
            error => {                      
                return [false, ""];
            }
        )
        .catch(
            error => {return [false, ""]}
        );
    }
}

export default{
    namespeced: true,
    state,
    getters,
    mutations,
    actions
}